import request from '@/utils/request_common';

export const getInstitutionInfoApi = (data: any) =>
    request({
      url: '/appInstitution/institutionAppFee/datas',
      method: 'post',
      data
    });

export const getInstitutionInfoCourseApi = (data: any) =>
  request({
    url: '/appInstitution/institutionAppFee/appFeeCourseDatas',
    method: 'post',
    data
  });

export const getCountryApi = () => request({
  url: '/appInstitution/institutionAppFee/InstitutionAppFeeCountrySelect',
  method: 'get'
})

export const getInstitutionApi = () => request({
  url: '/appInstitution/institutionAppFee/InstitutionAppFeeInstitutionSelect',
  method: 'get'
})

export const getMajorLevelApi = () => request({
  url: '/appInstitution/institutionAppFee/InstitutionAppFeeMajorLevelSelect',
  method: 'get'
})
